import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { AuthService } from './services/auth/auth.service';
import { CookieService } from './services/cookie/cookie.service';
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  session_response: any;
  private onDestroy = new Subject<void>();
  constructor(
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService ,
    private route: ActivatedRoute,
    private titleService: Title
  ) {
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
        gtag('config', 'UA-122489569-1',
          {
            'page_path': event.urlAfterRedirects
          }
        );

      }
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      let currentRoute = this.route.root;
      let title = '';
      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach(routes => {
          if (routes.outlet === 'primary') {
            title = routes.snapshot.data.title;
            currentRoute = routes;
          }
        });
      } while (currentRoute);
      if (title !== undefined ) {
        this.titleService.setTitle(title);
      }
    });
  }

  ngOnInit() {
    // console.log(window.location.hash);
    var params: any = {};
    if (window.location.hash && window.location.hash.split('?')[1]) {
      var hash = window.location.hash.split('?')[1];
      hash.split('&').map(hk => {
        let temp = hk.split('=');
        params[temp[0]] = temp[1]
      });
      if (params.pe) {
        this.cookieService.setCookie('personal_email', params.pe, 30);
      }
      if (params.utm_source) {
        this.cookieService.setCookie('utm_source', params.utm_source, 30);
      }
      if (params.utm_medium) {
        this.cookieService.setCookie('utm_medium', params.utm_medium, 30);
      }
      if (params.utm_campaign) {
        this.cookieService.setCookie('utm_campaign', params.utm_campaign, 30);
      }
    } else if (window.location.search) {
      params = new URLSearchParams(window.location.search);
      if (params.get('pe')) {
        this.cookieService.setCookie('personal_email', params.get('pe'), 30);
      }
      if (params.get('utm_source')) {
        this.cookieService.setCookie('utm_source', params.get('utm_source'), 30);
      }
      if (params.get('utm_medium')) {
        this.cookieService.setCookie('utm_medium', params.get('utm_medium'), 30);
      }
      if (params.get('utm_campaign')) {
        this.cookieService.setCookie('utm_campaign', params.get('utm_campaign'), 30);
      }
    }

    // this.authService.checkSession('1').subscribe((response: any) => {
    //   this.session_response = response;
    //   console.log('response', response)
    // }, err => {
    //   console.log(err);
    // }, () => {
    //   if (this.session_response && this.session_response.data) {
    //     if (this.session_response.code == 2 && this.session_response?.force_update_password == '1') {
    //       this.router.navigate(['login'], { state: { is_force_update_pass: true } });
    //     } else
    //     if (this.session_response.data?.sms_verified != '1' || this.session_response.data?.email_verified != '1' ) {
    //       this.router.navigate([`verify-account`], {
    //         queryParams: {
    //           mobile_number: this.session_response.data.mobile,
    //           country_code: this.session_response.data.country_code,
    //           office_email: this.session_response.data.office_email,
    //           is_verified: this.session_response.data.is_verified,
    //         },
    //         replaceUrl: true,
    //       },);
    //     } else {
    //       window.open(`${environment.base_url}/staff`, '_self');
    //     }
    //   }
    // });
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
